// Function to add underscores to the text content until the container width is filled
function addUnderscores(elements) {
    elements.forEach(element => {
        // Clear existing underscores
        element.textContent = element.textContent.replace(/_/g, "");

        const containerWidth = element.offsetWidth;
        const textWidth = element.scrollWidth;

        // Calculate the number of underscores needed to fill the remaining space
        // Consider a minimum space for underscores
        const availableSpace = Math.max(containerWidth - textWidth, 20);

        const computedStyles = getComputedStyle(element);
        const fontSize = parseFloat(computedStyles.fontSize); // Font size in pixels

        const underscoreWidth = fontSize * 0.1; // Adjust as needed based on font and styling

        let numberOfUnderscores = Math.floor(availableSpace / underscoreWidth);

        // Limit the maximum number of underscores to 3
        numberOfUnderscores = Math.min(2, numberOfUnderscores);

        // Ensure a minimum of 1 underscore
        numberOfUnderscores = Math.max(1, numberOfUnderscores);

        // Add underscores to fill the remaining space
        let underscores = "";
        for (let i = 0; i < numberOfUnderscores; i++) {
            underscores += "_";
        }

        // Append underscores to the text content instead of replacing it
        element.textContent += underscores;
    });
}

// Function to handle adding underscores on hover
function handleMenuUnderscores() {
    const menuItems = document.querySelectorAll('header .wp-block-navigation-item__label:not([data-wpml="label"])');
    
    menuItems.forEach(item => {
        item.addEventListener('mouseover', () => {
            addUnderscores([item]);
        });
        
        item.addEventListener('mouseout', () => {
            // Restore original text content when mouse leaves
            item.textContent = item.textContent.replace(/_/g, "");
        });
    });
}


// Function to handle adding underscores on page load and window resize
function handleUnderscores() {
    const paragraphs = document.querySelectorAll('.wp-block-post-excerpt__excerpt');
    const headings = document.querySelectorAll('.is-style-inifinite-underscores');
    addUnderscores(paragraphs);
    addUnderscores(headings);
}

// Execute the function on page load
document.addEventListener("DOMContentLoaded", handleUnderscores);

// Execute the function on window resize
window.addEventListener('resize', handleUnderscores);



// Execute the function to handle underscores on hover
document.addEventListener("DOMContentLoaded", handleMenuUnderscores);